
import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import { APP_CONFIG } from '@/config/app-config';
import { Auth } from '@/models/auth';
import authService from '@/services/auth-services';
import localStorage from '@/utility/localStorage';
import Notification from './Notification.vue';
import commonService from '@/services/common-services';

@Component({
    components: {
        'notification': Notification
    }
})
export default class AppHeader extends Vue {
    private isOpenMenuUser = false;
    private totalNotify = 0;

    get showMenuLeft() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get isToken() {
        return authProvider.isToken();
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private onOpenUserMenu() {
        this.isOpenMenuUser = !this.isOpenMenuUser;
    }

    private async created() {
      if (!this.rate) {
        await this.getRate();
      }
    }

    private async onLogout() {
        const dataRequest: Auth = {
            username: '',
            password: '',
            FirebaseToken: localStorage.get('FCM_Token')
        };

        const result  = await authService.logout(dataRequest);
        (window['getApp'] as any).$emit('APP_LOGOUT');
    }

    private onToggleMenu() {
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', !this.showMenuLeft);
    }

    private getTotalNotification(total: number) {
        this.totalNotify = total;
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
        (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
      }
    }
}
